
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

try {
  window.$ = window.jQuery = require('jquery');
  require('bootstrap-sass');
  require('datatables.net');
  require('datatables.net-bs');
  require('imagesloaded');
} catch (e) {
  /* eslint-disable no-console */
  console.log(e);
  /* eslint-enable no-console */
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.masonry = require('masonry-layout');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  /* eslint-disable no-console */
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
  /* eslint-enable no-console */
}

import toastr from 'toastr';

toastr.options.closeMethod = 'fadeOut';
toastr.options.closeDuration = 300;
toastr.options.closeEasing = 'swing';

window.toastr = toastr;

window.configs = {
  dropzoneTimeout: 1000 * 60 * 60,    //1 hour
};